import { render, staticRenderFns } from "./AnswerContent.vue?vue&type=template&id=2fbbd5cc&scoped=true&"
import script from "./AnswerContent.vue?vue&type=script&lang=js&"
export * from "./AnswerContent.vue?vue&type=script&lang=js&"
import style0 from "./AnswerContent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AnswerContent.vue?vue&type=style&index=1&id=2fbbd5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbbd5cc",
  null
  
)

export default component.exports